<template>
  <div class="layout-container">
    <!-- 导航栏（logo/搜索/下载/工具栏） -->
    <van-nav-bar class="app-nav-bar">
      <div class="bjh-nav-left" slot="left">
        <img class="bjh-icon" src="./bjh-icon.gif" alt="iocn">
        <img class="bjh-icon-text" src="./bjh-logo-text.png" alt="iocn">
      </div>
      <van-button
      slot="title"
      class="search-btn"
       icon="search"
       type="default"
       to="/search"
      >搜索</van-button>
      <template #right>
        <van-button class="download-class"
        @click="goToDownload()"
        color="linear-gradient(to right, #ff6034, #ee0a24)">下载APP</van-button>
      </template>
    </van-nav-bar>

    <!-- layout 子路由（二级路由） -->
    <keep-alive>
      <router-view class="secnd-router"></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'LayoutIndex',
  components: {},
  props: {},
  data () {
    return {}
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  methods: {
    goToDownload () {
      window.location.href = 'https://ie.bjd.com.cn/appstore/download'
    }
  }
}
</script>

<style lang="less" scoped>
.layout-container {

  /deep/ .van-nav-bar__title {
    margin-right: 85px;
  }
  .app-nav-bar {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    height: 42px;
    background-color: white;
    .bjh-nav-left {
      // display: flex;
      // align-items:center
      height: 42px;
      line-height: 42px;
      margin: 0 0;
      padding: 0 0;
      .bjh-icon {
        height: 34px;
        width: 34px;
        background-size: cover;
        display: inline-block;
        vertical-align: middle;
      }
      .bjh-icon-text {
        width: 45px;
        height: 15px;
        margin-left: 10px;
        background-size: cover;
        display: inline-block;
        vertical-align: middle;
      }
      // .bjh-text {
      //   margin-left: 10px;
      //   display: inline-block;
      //   vertical-align: middle;
      //   color: #D21220;
      //   font-size: 16px;
      // }
    }
    .search-btn {
      padding: 0 0;
      margin-top: 3px;
      width: 107px;
      height: 21px;
      border-radius: 3px;
      background: #f6f7f9;
      /deep/ .van-button__content {
        justify-content: flex-start;
      }
      .van-button__text {
        font-size: 8px;
        color: #c9cacb;
      }
      .van-icon::before {
        color: #bdbebe;
        margin-left: 7px;
      }
    }
    .download-class {
      width: 60px;
      height: 21px;
      padding: 0 0;
      // font-size: 12px;
      /deep/ .van-button__text {
        font-size: 10px;
      }
    }
  }

  .secnd-router {
    margin: 0 12.5px;
    margin-top: 42px;
  }
}
</style>
